import React from "react";

import {
    FiPlus,
    FiRefreshCcw,
} from "react-icons/fi";

import "./EmployeeCommon.css";


const EmployeePageHeader = ({
    eyebrow =
        "EMPLOYEE MANAGEMENT",

    title,

    description = "",

    actionLabel = "",

    actionIcon,

    onAction,

    onRefresh,

    loading = false,

    hideAction = false,
}) => {

    return (

        <div className="employee-common-page-header">

            <div className="employee-common-page-title">

                <span>
                    {eyebrow}
                </span>

                <h1>
                    {title}
                </h1>


                {
                    description
                        ? (
                            <p>
                                {description}
                            </p>
                        )
                        : null
                }

            </div>


            <div className="employee-common-page-actions">

                {
                    onRefresh
                        ? (
                            <button
                                type="button"
                                className="employee-common-refresh-btn"
                                onClick={
                                    onRefresh
                                }
                                disabled={
                                    loading
                                }
                                title="Refresh"
                            >

                                <FiRefreshCcw
                                    className={
                                        loading
                                            ? "employee-common-spin"
                                            : ""
                                    }
                                />

                            </button>
                        )
                        : null
                }


                {
                    !hideAction &&
                    actionLabel &&
                    onAction
                        ? (
                            <button
                                type="button"
                                className="employee-common-primary-btn"
                                onClick={
                                    onAction
                                }
                                disabled={
                                    loading
                                }
                            >

                                {
                                    actionIcon ||
                                    <FiPlus />
                                }

                                <span>
                                    {actionLabel}
                                </span>

                            </button>
                        )
                        : null
                }

            </div>

        </div>

    );

};


export default EmployeePageHeader;